<template>
  <div id="app">
    <div id="header">
      <svg @click="switchMode('main')" width="114" height="44" viewBox="0 0 114 44" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M39.7015 0H4.53516V31.9908H39.7015V0Z" fill="#FFF200"/>
        <path
            d="M9.4145 20.3587L8.15429 24.1236H6.53418L10.6572 12.1543H12.5478L16.6889 24.1236H15.0145L13.7181 20.3587H9.4145ZM13.3932 19.151L12.2048 15.7061C11.9349 14.9247 11.755 14.2146 11.5744 13.522H11.5382C11.3583 14.2321 11.1602 14.9603 10.9259 15.6886L9.73754 19.1516H13.3932V19.151Z"
            fill="#3E3F41"/>
        <path
            d="M19.3727 12.3135C20.1649 12.1535 21.2989 12.0647 22.3792 12.0647C24.0536 12.0647 25.1339 12.3666 25.8899 13.0417C26.5022 13.5743 26.844 14.3913 26.844 15.3152C26.844 16.8954 25.8356 17.9437 24.5572 18.3694V18.4225C25.4932 18.742 26.0517 19.5946 26.3398 20.8379C26.7359 22.5075 27.0239 23.6614 27.2757 24.1234H25.6556C25.4576 23.7858 25.1876 22.7557 24.8453 21.2642C24.4854 19.6127 23.8369 18.9907 22.4148 18.9376H20.9384V24.1234H19.3721V12.3135H19.3727ZM20.939 17.7655H22.5416C24.2161 17.7655 25.2782 16.8598 25.2782 15.4921C25.2782 13.9469 24.1442 13.2724 22.4879 13.2543C21.7319 13.2543 21.1914 13.3255 20.9396 13.3968V17.7655H20.939Z"
            fill="#3E3F41"/>
        <path d="M32.426 13.4675H28.7354V12.1536H37.7193V13.4675H34.0105V24.1229H32.426V13.4675Z" fill="#3E3F41"/>
        <path
            d="M53.9254 23.59C53.2232 23.8388 51.8368 24.247 50.1985 24.247C48.3623 24.247 46.8497 23.7851 45.6613 22.6662C44.6173 21.6716 43.9688 20.0733 43.9688 18.2086C43.9869 14.6393 46.4711 12.0283 50.5403 12.0283C51.9449 12.0283 53.0426 12.3302 53.565 12.5784L53.1869 13.8398C52.539 13.5554 51.7287 13.3248 50.5041 13.3248C47.5513 13.3248 45.6251 15.1363 45.6251 18.1374C45.6251 21.1741 47.4795 22.9681 50.306 22.9681C51.332 22.9681 52.0342 22.8262 52.3947 22.6486V19.0793H49.928V17.836H53.9248V23.59H53.9254Z"
            fill="white"/>
        <path
            d="M59.184 20.3584L57.9238 24.1233H56.3037L60.4267 12.1541H62.3173L66.4585 24.1233H64.784L63.4876 20.3584H59.184ZM63.1627 19.1507L61.9744 15.7058C61.7045 14.9245 61.5245 14.2144 61.344 13.5217H61.3077C61.1278 14.2319 60.9297 14.9601 60.6954 15.6883L59.5071 19.1513H63.1627V19.1507Z"
            fill="white"/>
        <path d="M69.1416 12.1536H70.708V22.827H75.8931V24.1235H69.1416V12.1536Z" fill="white"/>
        <path
            d="M84.8246 18.5114H80.1074V22.827H85.3644V24.1235H78.541V12.1536H85.0945V13.45H80.1074V17.2325H84.8246V18.5114Z"
            fill="white"/>
        <path
            d="M88.3014 12.3135C89.0936 12.1535 90.2276 12.0647 91.3079 12.0647C92.9823 12.0647 94.0626 12.3666 94.8186 13.0417C95.4309 13.5743 95.7727 14.3913 95.7727 15.3152C95.7727 16.8954 94.7643 17.9437 93.4859 18.3694V18.4225C94.4219 18.742 94.9804 19.5946 95.2685 20.8379C95.6646 22.5075 95.9526 23.6614 96.2044 24.1234H94.5843C94.3863 23.7858 94.1163 22.7557 93.774 21.2642C93.4141 19.6127 92.7656 18.9907 91.3435 18.9376H89.8671V24.1234H88.3008V12.3135H88.3014ZM89.8677 17.7655H91.4703C93.1448 17.7655 94.2069 16.8598 94.2069 15.4921C94.2069 13.9469 93.0729 13.2724 91.416 13.2543C90.66 13.2543 90.1195 13.3255 89.8677 13.3968V17.7655Z"
            fill="white"/>
        <path
            d="M101.392 24.1235V19.044L97.5566 12.1536H99.3392L101.05 15.4566C101.518 16.3623 101.878 17.0905 102.256 17.9251H102.293C102.634 17.1437 103.049 16.3623 103.517 15.4566L105.263 12.1536H107.045L102.977 19.0265V24.1235H101.392Z"
            fill="white"/>
        <path
            d="M41.0287 36.7237C41.3796 36.9369 41.8934 37.1144 42.4333 37.1144C43.2346 37.1144 43.7031 36.6972 43.7031 36.0933C43.7031 35.5342 43.3795 35.2141 42.5601 34.9038C41.5692 34.5578 40.9569 34.0517 40.9569 33.2082C40.9569 32.2759 41.7401 31.5833 42.9194 31.5833C43.5407 31.5833 43.9912 31.7252 44.2611 31.8761L44.0449 32.5065C43.8462 32.4002 43.4411 32.2227 42.8922 32.2227C42.0637 32.2227 41.7485 32.7112 41.7485 33.1194C41.7485 33.6786 42.1175 33.9539 42.955 34.2734C43.9815 34.664 44.5038 35.1525 44.5038 36.0311C44.5038 36.9544 43.8106 37.7533 42.3783 37.7533C41.7932 37.7533 41.1537 37.5848 40.8301 37.3716L41.0287 36.7237Z"
            fill="white"/>
        <path
            d="M47.0052 35.7822L46.3748 37.6643H45.5645L47.6266 31.6809H48.5722L50.6433 37.6643H49.8058L49.1573 35.7822H47.0052ZM48.9949 35.179L48.4007 33.4568C48.266 33.0661 48.1755 32.7111 48.0855 32.3651H48.0674C47.9774 32.7201 47.8784 33.0842 47.7612 33.4477L47.1671 35.179H48.9949Z"
            fill="white"/>
        <path
            d="M51.9834 37.6643V31.6809H52.839L54.7846 34.708C55.2345 35.409 55.5853 36.0394 55.8739 36.6523L55.892 36.6439C55.8202 35.845 55.8021 35.1168 55.8021 34.1844V31.6809H56.5406V37.6643H55.7483L53.8209 34.6282C53.3976 33.9622 52.993 33.2787 52.6862 32.6308L52.6597 32.6398C52.7044 33.394 52.7225 34.1138 52.7225 35.1077V37.6643H51.9834Z"
            fill="white"/>
        <path
            d="M60.7139 31.6809H63.9824V32.3288H61.4977V34.3173H63.7941V34.9567H61.4977V37.6643H60.7145V31.6809H60.7139Z"
            fill="white"/>
        <path
            d="M65.5479 31.7606C65.944 31.6809 66.511 31.6362 67.0514 31.6362C67.8889 31.6362 68.4294 31.7872 68.8074 32.1241C69.1135 32.3904 69.2844 32.7992 69.2844 33.2606C69.2844 34.051 68.7802 34.5745 68.1413 34.7877V34.8142C68.6093 34.9743 68.8883 35.4006 69.0326 36.0219C69.2307 36.8564 69.3744 37.4337 69.5012 37.6644H68.6902C68.5912 37.4959 68.4565 36.9808 68.285 36.2351C68.1051 35.4096 67.7808 35.0986 67.0695 35.0721H66.331V37.6644H65.5479V31.7606ZM66.331 34.4864H67.1323C67.9698 34.4864 68.5006 34.0335 68.5006 33.3499C68.5006 32.5776 67.9336 32.2401 67.1052 32.2316C66.7272 32.2316 66.4566 32.2672 66.331 32.3023V34.4864Z"
            fill="white"/>
        <path
            d="M71.8665 35.7822L71.2361 37.6643H70.4258L72.4879 31.6809H73.4335L75.5047 37.6643H74.6671L74.0186 35.7822H71.8665ZM73.8562 35.179L73.262 33.4568C73.1274 33.0661 73.0368 32.7111 72.9468 32.3651H72.9287C72.8387 32.7201 72.7397 33.0842 72.6225 33.4477L72.0284 35.179H73.8562Z"
            fill="white"/>
        <path
            d="M76.8438 37.6643V31.6809H77.6994L79.645 34.708C80.0948 35.409 80.4456 36.0394 80.7343 36.6523L80.7524 36.6439C80.6805 35.845 80.6624 35.1168 80.6624 34.1844V31.6809H81.4009V37.6643H80.6087L78.6812 34.6282C78.2579 33.9622 77.8534 33.2787 77.5466 32.6308L77.52 32.6398C77.5647 33.394 77.5828 34.1138 77.5828 35.1077V37.6643H76.8438Z"
            fill="white"/>
        <path
            d="M87.4577 37.4695C87.1697 37.6114 86.5936 37.7533 85.8545 37.7533C84.1438 37.7533 82.8564 36.6881 82.8564 34.7256C82.8564 32.8525 84.1438 31.5833 86.026 31.5833C86.782 31.5833 87.2596 31.7433 87.4667 31.8495L87.2777 32.48C86.9807 32.3381 86.5568 32.2318 86.0532 32.2318C84.6299 32.2318 83.6849 33.1285 83.6849 34.6997C83.6849 36.1646 84.5405 37.1054 86.0175 37.1054C86.4946 37.1054 86.9807 37.0075 87.2959 36.8566L87.4577 37.4695Z"
            fill="white"/>
        <path d="M89.6709 31.6809V37.6643H88.8877V31.6809H89.6709Z" fill="white"/>
        <path
            d="M91.3803 36.7237C91.7311 36.9369 92.2444 37.1144 92.7848 37.1144C93.5861 37.1144 94.0547 36.6972 94.0547 36.0933C94.0547 35.5342 93.731 35.2141 92.9116 34.9038C91.9207 34.5578 91.3084 34.0517 91.3084 33.2082C91.3084 32.2759 92.0916 31.5833 93.2709 31.5833C93.8923 31.5833 94.3427 31.7252 94.6127 31.8761L94.3965 32.5065C94.1978 32.4002 93.7926 32.2227 93.2438 32.2227C92.4153 32.2227 92.1001 32.7112 92.1001 33.1194C92.1001 33.6786 92.469 33.9539 93.3066 34.2734C94.3331 34.664 94.8554 35.1525 94.8554 36.0311C94.8554 36.9544 94.1622 37.7533 92.7299 37.7533C92.1448 37.7533 91.5053 37.5848 91.1816 37.3716L91.3803 36.7237Z"
            fill="white"/>
        <path
            d="M100.618 37.4695C100.33 37.6114 99.7538 37.7533 99.0147 37.7533C97.304 37.7533 96.0166 36.6881 96.0166 34.7256C96.0166 32.8525 97.304 31.5833 99.1855 31.5833C99.9415 31.5833 100.419 31.7433 100.626 31.8495L100.437 32.48C100.14 32.3381 99.7163 32.2318 99.2127 32.2318C97.7895 32.2318 96.8445 33.1285 96.8445 34.6997C96.8445 36.1646 97.7001 37.1054 99.1771 37.1054C99.6541 37.1054 100.14 37.0075 100.455 36.8566L100.618 37.4695Z"
            fill="white"/>
        <path
            d="M107.044 34.6108C107.044 36.6699 105.774 37.7622 104.226 37.7622C102.623 37.7622 101.498 36.537 101.498 34.7261C101.498 32.8264 102.695 31.5837 104.316 31.5837C105.973 31.5831 107.044 32.8349 107.044 34.6108ZM102.336 34.708C102.336 35.9863 103.038 37.1318 104.271 37.1318C105.514 37.1318 106.216 36.0044 106.216 34.6464C106.216 33.4568 105.586 32.2141 104.281 32.2141C102.983 32.2135 102.336 33.394 102.336 34.708Z"
            fill="white"/>
        <path d="M49.8902 43.114H43.8506V43.8773H49.8902V43.114Z" fill="white"/>
        <path d="M107.919 20.5813H113V3.04346H1V35.158H38.4102" stroke="white" stroke-width="0.7702"
              stroke-miterlimit="10"/>
      </svg>
      <div>
        <svg v-if="mode!=='main'" @click="switchMode('main')" style="margin-right: 2rem" width="25" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M22.8596 22.1821L15.8614 15.1838C17.315 13.5699 18.2084 11.442 18.2084 9.10414C18.2083 4.08416 14.1242 0 9.10418 0C4.08416 0 0 4.08416 0 9.10418C0 14.1242 4.08416 18.2084 9.10418 18.2084C11.442 18.2084 13.5699 17.315 15.1839 15.8614L22.1821 22.8596C22.2756 22.9532 22.3983 23 22.5209 23C22.6435 23 22.766 22.9532 22.8597 22.8596C23.0468 22.6724 23.0468 22.3692 22.8596 22.1821ZM9.10418 17.25C4.61294 17.25 0.958363 13.5959 0.958363 9.10418C0.958363 4.61249 4.61294 0.958318 9.10418 0.958318C13.5954 0.958318 17.25 4.61244 17.25 9.10418C17.25 13.5959 13.5954 17.25 9.10418 17.25Z"
              fill="white"/>
        </svg>
        <svg @click="switchMode('favourites')" width="25" height="23" viewBox="0 0 25 23" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
              d="M18.4896 0C15.7166 0 13.4262 2.57568 12.5 3.79131C11.5738 2.57568 9.28345 0 6.5104 0C2.92056 0 0 3.30049 0 7.35679C0 9.56982 0.878418 11.6323 2.41597 13.0437C2.43833 13.0824 2.46582 13.118 2.49785 13.15L12.1323 22.7646C12.234 22.8658 12.3667 22.9167 12.5 22.9167C12.6333 22.9167 12.7665 22.8658 12.8683 22.7641L22.8231 12.8128L22.9258 12.7131C23.0072 12.6363 23.0876 12.5585 23.1776 12.4588C23.2152 12.4217 23.2462 12.38 23.2702 12.3347C24.3866 10.9675 25 9.2041 25 7.35679C25 3.30049 22.0795 0 18.4896 0ZM22.4035 11.7488C22.3892 11.7656 22.376 11.7833 22.3643 11.8017C22.3155 11.8576 22.2621 11.9069 22.2092 11.9573L12.4995 21.6599L3.35288 12.5315C3.32339 12.4735 3.28218 12.4207 3.23184 12.3764C1.8397 11.1608 1.04165 9.33125 1.04165 7.35679C1.04165 3.87471 3.49478 1.0417 6.5104 1.0417C9.49199 1.0417 12.0366 4.93066 12.0621 4.96982C12.2543 5.26685 12.7457 5.26685 12.9379 4.96982C12.9634 4.93066 15.508 1.0417 18.4896 1.0417C21.5052 1.0417 23.9583 3.87476 23.9583 7.35679C23.9583 8.99761 23.406 10.5576 22.4035 11.7488Z"
              fill="white"/>
        </svg>
      </div>
    </div>
    <div id="control" v-if="mode==='main'">
      <div>
        <input type="text" id="searchInput" v-model="searchInput">
        <div id="searchButton" @click="searchPhotos()">
          <svg width="18" height="18" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.8596 22.1821L15.8614 15.1838C17.315 13.5699 18.2084 11.442 18.2084 9.10414C18.2083 4.08416 14.1242 0 9.10418 0C4.08416 0 0 4.08416 0 9.10418C0 14.1242 4.08416 18.2084 9.10418 18.2084C11.442 18.2084 13.5699 17.315 15.1839 15.8614L22.1821 22.8596C22.2756 22.9532 22.3983 23 22.5209 23C22.6435 23 22.766 22.9532 22.8597 22.8596C23.0468 22.6724 23.0468 22.3692 22.8596 22.1821ZM9.10418 17.25C4.61294 17.25 0.958363 13.5959 0.958363 9.10418C0.958363 4.61249 4.61294 0.958318 9.10418 0.958318C13.5954 0.958318 17.25 4.61244 17.25 9.10418C17.25 13.5959 13.5954 17.25 9.10418 17.25Z"
                fill="black"/>
          </svg>
        </div>
      </div>
    </div>
    <div id="main">
      <div v-if="mode==='main'">
        <PhotosComponent :photos="randomPhotos" :select="selectItem"/>
      </div>
      <div v-else-if="mode==='search'">
        <PhotosComponent :photos="searchedPhotos" :select="selectItem"/>
      </div>
      <div v-else-if="mode==='favourites'">
        <div id="headLevelOne">
          <h1>Избранное</h1>
        </div>
        <PhotosComponent :photos="favourite_photos" :select="selectItem"/>
      </div>
      <div v-else-if="mode==='single'" id="single">
        <PhotoComponent :add-to-favourite="addToFavourite" :photo="selectedItems[selectedItems.length-1]"/>
      </div>
    </div>
  </div>
</template>

<script>
import {createApi} from "unsplash-js";
import config from "../config";
import PhotosComponent from "@/components/Photos";
import PhotoComponent from "@/components/Photo";
import "@/assets/reset.css"
import "@/assets/style.css"

export default {
  name: 'App',
  components: {PhotoComponent, PhotosComponent},
  data() {
    return {
      randomPhotos: [],
      searchedPhotos: [],
      favourite_photos: [],
      searchInput: "cat",
      selectedItems: [],
      mode: "main",
      modes: ["main", "search", "favourites", "single"]
    }
  },
  mounted() {
    this.unsplash = createApi({
      accessKey: config.UNSPLASH_ACCESS_KEY
    })
    this.unsplash.photos.getRandom({count: 8}).then(data => {
      this.randomPhotos = data.response
    }).catch(e => {
      console.log(e)
    })
  },
  methods: {
    addToFavourite(item) {
      this.favourite_photos.push(item)
    },
    searchPhotos() {
      this.unsplash?.search?.getPhotos?.({
        query: this.searchInput || "",
        perPage: 8
      })
          .then(data => {
            this.searchedPhotos = data.response.results
            this.switchMode("search")
          })
          .catch(e => {
            console.log(e)
          })
    },
    selectItem(item) {
      this.selectedItems = this.selectedItems.filter(e => {
        return item.urls.small !== e.urls.small
      })
      this.selectedItems.push(item)
      this.switchMode("single")
    },
    switchMode(modeType) {
      this.modes.includes(modeType) ? this.mode = modeType : this.mode = this.modes[0]
    }
  }
}
</script>

<style>

</style>
